import { showModal } from '@wikom/wikom-modal';
import { useAppDispatch } from '@app/store';
var useShowModal = function (modalName) {
    var dispatch = useAppDispatch();
    return function () { return dispatch(showModal(modalName)); };
};
export default useShowModal;
